const InitialIcon = ({ initials }) => {
  return (
    <div className='flex items-center justify-center h-6 w-6 bg-blue-500 rounded-full mb-0'>
      <p className='text-white text-sm font-bold m-0'>{initials}</p>
    </div>
  );
};

export default InitialIcon;
